export function replaceRootHeaderAndFooter(parentStory: any, childStory: any) {
    const rootHeader = parentStory.content.page.find((component) => component.component === 'L4HeaderContainer');

    const rootFooter = parentStory.content.page.find((component) => component.component === 'L4FooterContainer');

    childStory.content.page = childStory.content.page.map((component: any) => {
        if (component.component === 'L4HeaderContainer') {
            return rootHeader;
        } else if (component.component === 'L4FooterContainer') {
            return rootFooter;
        } else {
            return component;
        }
    });

    return childStory;
}
